<template>
  <el-dialog
      :title="confirm.title"
      :visible.sync="confirm.show"
      :width="confirm.width || '30%'"
      :before-close="cancel">
    <span v-html="confirm.message"></span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="agree">{{ $t('common.yes') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: "Confirm",
    data: function () {
      return {}
    },
    methods: {
      agree: function () {
        if (typeof this.confirm.callback === 'function') {
          this.confirm.callback()
        }

        this.$store.commit('closeConfirm')
      },
      cancel: function () {
        this.$store.commit('closeConfirm')
      }
    },
    computed: {
      ...mapState(['confirm'])
    }
  }
</script>

<style lang="scss">
  .el-dialog__body {
    word-break: unset!important;
  }
</style>
